import styled from '@emotion/styled';
import { AlertProvider } from '../shared/AlertProvider';
import Sidebar from '../shared/sidebar/Sidebar';
import { Outlet } from 'react-router-dom';
import ScrollToTop from '../shared/ScrollToTop';
import AlertComponent from '../shared/AlertComponent';
import { getVar } from '../../theme/ui-variables/ui-variables';
import { getColor } from '../../theme/colors/colors';
import PageHeader from '../shared/page-header/PageHeader';
import { WorkspaceProvider } from '../../context/WorkspaceContext';



function SideBarWithMainPage() {
    return (
        <WorkspaceProvider>
        <SidebarAndMainWrapper>
            <Sidebar />
            <AlertProvider>
                <Main>
                    <PageHeader />
                    <ScrollToTop>
                        <Outlet />
                        <AlertComponent />
                    </ScrollToTop>
                </Main>
            </AlertProvider>
        </SidebarAndMainWrapper>
        </WorkspaceProvider>

    );
}

export default SideBarWithMainPage;

const SidebarAndMainWrapper = styled.div`
  display: flex;
  height: calc(100% - ${getVar('headerHeight')});;
  overflow: hidden;
`;

const Main = styled.main`
  width: calc(100% - ${getVar('sidebarWidth')});
  height: 100%;
  padding: ${getVar('mainPadding')};
  background-color: ${getColor('secondary')};
  overflow-y: auto;
`;